const React = require("react");
const Tooltip = require("../Tooltip/A");
const formatNumCoin = require("../../../utils/formatNumCoin");
const formatNumCurrency = require("../../../utils/formatNumCurrency");
const formatNumFiat = require("../../../utils/formatNumFiat");

module.exports = ({value, type, symbol}) => {
  const valueHandlers = {
    coin: formatNumCoin,
    currency: formatNumCurrency,
    fiat: formatNumFiat
  };

  const valueHandler = type && valueHandlers[type];
  const number = valueHandler ? valueHandler(value) : value;

  const content = [number, symbol].join(' ');

  return !!Number(value)
    ? (
      <Tooltip
        title={[value, symbol].join(' ')}
        value={value}
      >
        {content}
      </Tooltip>
    ) : (
      content
    )
}
